import { IColor } from "@/consts/Colors";
import { FC, useCallback, useState } from "react";
import { UseFormRegisterReturn } from "react-hook-form";
import ColorGridTile from "@/components/ColorGridTile";

interface Props {
  id: string;
  value: string;
  color: IColor;
  register: UseFormRegisterReturn;
  defaultChecked?: boolean;
}

const CheckableColorGridTile: FC<Props> = ({
  id,
  value,
  color,
  register,
  defaultChecked = false,
}): JSX.Element => {
  const [checked, setChecked] = useState<boolean>(defaultChecked);

  const onTouchEnd = useCallback(
    () => setChecked(!checked),
    [checked, setChecked],
  );

  return (
    <label
      htmlFor={id}
      className={`${checked ? "bg-gray-50" : ""}`}
      onTouchEnd={onTouchEnd}
    >
      <ColorGridTile color={color} />

      <input
        {...register}
        id={id}
        className="hidden"
        type="checkbox"
        value={value}
      />
    </label>
  );
};
export default CheckableColorGridTile;
